import * as Sentry from '@sentry/react'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { TooltipProvider } from '@/components/ui'
import { AppError, ErrorBoundary, NotFound } from '@/modules/errors/components'
import { TrackingProvider } from '@/services/tracking'
import { routeTree } from './routeTree.gen'
import { captureException } from './services/monitoring'
import { createScrollOnNewPageOnly } from './utils/routing/scrollOnNewPageOnly'
import '@/services/monitoring/bootstrap'

import './styles.css'

const router = createRouter({
  routeTree,
  defaultErrorComponent: ({ error, reset, ...props }) => {
    captureException(error)
    return <AppError error={error} reset={reset} {...props} />
  },
  defaultNotFoundComponent: NotFound,
  defaultPreload: 'intent',
  scrollRestoration: createScrollOnNewPageOnly(),
  // The app scrolls inside <main>, not the window, so the router must reset it on new pages.
  scrollToTopSelectors: ['main'],
})

// Caught errors are already reported by ErrorBoundary; these add the component stack to the rest.
ReactDOM.createRoot(document.getElementById('root'), {
  onUncaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <React.StrictMode>
    <TrackingProvider>
      <ErrorBoundary fallback={({ error: props }) => <AppError {...props} />}>
        <TooltipProvider delayDuration={200}>
          <RouterProvider router={router} />
        </TooltipProvider>
      </ErrorBoundary>
    </TrackingProvider>
  </React.StrictMode>,
)
